import { render, staticRenderFns } from "./my-profile-admin-form.vue?vue&type=template&id=7008afd0&"
import script from "./my-profile-admin-form.vue?vue&type=script&lang=js&"
export * from "./my-profile-admin-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports